import { JSX, useMemo } from 'react'
import Account from './AccountStep'
import CompanyInfo from './CompanyInfoStep'
import EmailStep from './EmailStep'
import Form from './Form'
import Confirmation from '../../createPassword/confirmation'
import EmailVerificationStep from './EmailVerificationStep'
import { ActivationEmailStatus } from 'src/graphql/generated/graphql-types'
import AdditinonalUserRequestSent from './AdditinonalUserRequestSent'

export enum State {
  email,
  companyInfo,
  account,
  emailVerification,
  confirmation,
  password,
  ongoingActivation,
  additionalUserRequestSent,
}

export type StandardRegisterProps = {
  firstName: string
  lastName: string
  email: string
  password: string
  isAuthenticated: boolean
  organizationNumber: string
  companyName: string
  preRegistrationToken: string | null
  returnUrl: string | null
  cartId: number | null
  disallowNewContacts: boolean
  acceptAccountTerms: boolean
  offersByEmail: boolean
  companyNameSetByOrgNumber: boolean
  registrationState?: any
  setRegistrationState?: any
  name?: string
  additionalInformation?: string,
  additionalUserRequest?: boolean,
}

const StandardRegister = (props: StandardRegisterProps) => {

  const handleStateChange = (stateNext: State) => {
    props.setRegistrationState(stateNext)
  }

  const content: JSX.Element = useMemo(() => {
    const onNavigateBack = () => {
      props.setRegistrationState(props.registrationState - 1)
    }
    switch (props.registrationState) {
      case State.email:
        return <EmailStep onNavigateNext={(emailActivationStatus) => {
          if (emailActivationStatus === ActivationEmailStatus.OngoingActivation) {
            handleStateChange(State.ongoingActivation)
          } else {
            handleStateChange(State.companyInfo)
          }
        }
        } />

      case State.companyInfo:
        return <CompanyInfo onStateChange={(state) => handleStateChange(state)} onNavigateBack={() => onNavigateBack()} />

      case State.account:
        return <Account onNavigateBack={() => onNavigateBack()} />

      case State.emailVerification:
        return <EmailVerificationStep />

      case State.ongoingActivation:
        return <EmailVerificationStep emailActivationStatus={ActivationEmailStatus.OngoingActivation} />

      case State.confirmation:
        return <Confirmation />
      case State.additionalUserRequestSent:
        return <AdditinonalUserRequestSent />
      default:
        return <></>
    }
  }, [props.registrationState])

  return (
    <Form onStateChange={handleStateChange} state={props.registrationState} defaultValues={props} {...props} showStepper={(props.registrationState !== State.emailVerification) && (props.registrationState !== State.additionalUserRequestSent)}>
      {content}
    </Form>
  )
}

export default StandardRegister
